import { useEffect } from 'react';
import { log } from 'log';
import { pick } from 'ramda';
import { useGetURLTemplate } from 'server';
import { useDispatch } from 'react-redux';
import { getScript } from 'js/utils/scripts.util';
import { useSportsbookSelector } from 'js/store/hooks';

import * as constants from '../constants';
import * as actions from '../store/actions';

export const useSportsbookFetch = () => {
    const getURLTemplate = useGetURLTemplate();
    const dispatch = useDispatch();
    const { globalSportsScriptURL, globalSportsScriptPromise } = window;
    const {
        isNeedToStart,
        isURLTemplatesFetched,
        sportsbookIntegrationURL,
        isIntegrationScriptFetched,
        isIntegrationScriptFetching
    } = useSportsbookSelector(pick([
        'isNeedToStart',
        'isURLTemplatesFetched',
        'sportsbookIntegrationURL',
        'isIntegrationScriptFetched',
        'isIntegrationScriptFetching'
    ]));

    useEffect(() => {
        if (isNeedToStart && !isURLTemplatesFetched) {
            if (globalSportsScriptURL) {
                dispatch(actions.setIntegrationScriptURL(globalSportsScriptURL));

                return;
            }

            getURLTemplate({ urlTypeList: [constants.SPORTS_SCRIPT_URL_TEMPLATE] })
                .then((url) => dispatch(actions.setIntegrationScriptURL(url || '')))
                .catch(() => dispatch(actions.setIntegrationScriptURL('')));
        }
    }, [isURLTemplatesFetched, getURLTemplate, dispatch, isNeedToStart, globalSportsScriptURL]);

    useEffect(() => {
        if (isNeedToStart && isURLTemplatesFetched && !sportsbookIntegrationURL) {
            log('error', `[SPORTSBOOK | Portal] sportsbook integration URL '${constants.SPORTS_SCRIPT_URL_TEMPLATE}' is not configured`);

            dispatch(actions.setIntegrationScriptError());

            return;
        }

        if (!isNeedToStart || isIntegrationScriptFetched || isIntegrationScriptFetching || !isURLTemplatesFetched) {
            return;
        }

        dispatch(actions.setIntegrationScriptFetching());

        const scriptPromise = globalSportsScriptPromise || getScript(sportsbookIntegrationURL);

        scriptPromise
            .then(() => dispatch(actions.setIntegrationScriptFetched()))
            .catch(() => dispatch(actions.setIntegrationScriptError()));
    }, [
        dispatch,
        isNeedToStart,
        isURLTemplatesFetched,
        sportsbookIntegrationURL,
        globalSportsScriptPromise,
        isIntegrationScriptFetched,
        isIntegrationScriptFetching
    ]);
};
